/**
 * The edit and delete buttons of a comment stay out of sight until its row is
 * hovered or holds the keyboard focus, so that a thread reads as text. On a
 * screen without hover (a tablet), they are always shown: nothing would
 * reveal them there. Shared by the CRM thread and the invoice comments tab.
 */
export const COMMENT_ROW_CLASS = 'group';

export const COMMENT_ACTIONS_REVEAL_CLASS =
  'opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 focus-within:opacity-100 [@media(hover:none)]:opacity-100 transition-opacity';
